import React from "react";
import { useLang } from "../lib/LanguageContext";
import PageHeader from "../components/PageHeader";
import { Trophy, Music, BookOpen, HeartHandshake, Sparkles, CheckCircle2 } from "lucide-react";

const ICONS = [Trophy, Music, BookOpen, HeartHandshake, Sparkles];

// Mapped to translation category order: क्रीडा, सांस्कृतिक, शैक्षणिक, सामाजिक, चारित्र्य
const ACT_IMGS = [
  "/site/act-sports.png",
  "/site/act-cultural.png",
  "/site/act-academic.png",
  "/site/act-social.png",
  "/site/act-character.png",
];

const Activities = () => {
  const { t } = useLang();
  const p = t.activitiesPg;

  return (
    <div data-testid="activities-page">
      <PageHeader eyebrow={t.nav.activities} title={p.title} subtitle={p.sub} testId="activities-header" />

      <section className="section-pad">
        <div className="container-school space-y-16">
          {p.categories.map((c, i) => {
            const Icon = ICONS[i] || Sparkles;
            const isEven = i % 2 === 0;
            return (
              <div key={i} className={`grid lg:grid-cols-2 gap-10 items-center ${isEven ? "" : "lg:grid-flow-dense"}`} data-testid={`activity-category-${i}`}>
                <div className={isEven ? "" : "lg:col-start-2"}>
                  <div className="w-14 h-14 rounded-2xl bg-school-secondary/20 flex items-center justify-center mb-5">
                    <Icon className="w-7 h-7 text-school-primary" />
                  </div>
                  <h3 className="font-heading font-extrabold text-3xl md:text-4xl text-school-primary">{c.title}</h3>
                  <ul className="mt-6 space-y-3">
                    {c.items.map((it, j) => (
                      <li key={j} className="flex items-start gap-3 text-base md:text-lg text-school-text">
                        <CheckCircle2 className="w-5 h-5 text-school-accent shrink-0 mt-1" />
                        <span>{it}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className={isEven ? "" : "lg:col-start-1 lg:row-start-1"}>
                  <div className="rounded-3xl w-full bg-white border border-school shadow-xl overflow-hidden aspect-[4/3] flex items-center justify-center p-4">
                    <img src={ACT_IMGS[i % ACT_IMGS.length]} alt={c.title} loading="lazy" className="max-w-full max-h-full object-contain" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default Activities;
